import '../styles/style.scss';
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
import { SwipeListener } from "./SwipeListener.js";
import { GSAPCountdown } from "./GSAPCountdown.js";
import GestureRecognizer from './GestureRecognizer.js';
import { SoccerBallController } from './Soccerballcontroller.js';
import { VideoController } from './VideoController.js';
import AdContent from './AdContent.js';
import { SocialShare } from './SocialShare.js';



console.log(AdContent["eng"]);


//gsap.registerPlugin(Draggable, InertiaPlugin);
gsap.registerPlugin(Draggable, MotionPathPlugin, MotionPathHelper);

import { CanvasSequencePlayer } from "./CanvasSequencePlayer.js";

//import data from '../data.yaml';


switch (import.meta.env.MODE) {
    case 'development':
        console.log('Running in Development Mode');
        window.environment = 'development';
        break;
    case 'production':
        console.log('Running in Production Mode');
        window.environment = 'production';
        break;
    default:
        console.log('Running in Test Mode');
        window.environment = 'testing';
        break;
}

const gameData = {
    "gameTimer": 60,
    "exitUrl": "https://www.amazon.com/Young-Sherlock/dp/B0G2BV1WV7",
    "vanity-url": "https://www.vanity-url.com",
    "completeScope": 5,
    "kickup-timer": 15,
    "fullscreen": false
}

function getVersionByEtDeadline(deadlineEtStr) {
    // Expected deadlineEtStr format: "YYYY-MM-DD HH:mm" (24-hour format)
    // Example: "2026-05-28 21:30"

    const now = new Date();

    // 1. Force the current time to match the America/New_York timezone layout
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23' // Forces 24-hour format (00-23) to avoid 12-hour AM/PM sorting issues
    });

    // 2. Break down the current ET time into pieces
    const parts = formatter.formatToParts(now);
    const dateObj = {};
    parts.forEach(part => {
        if (part.type !== 'literal') {
            dateObj[part.type] = part.value;
        }
    });

    // 3. Reconstruct into a sortable string: "YYYY-MM-DD HH:mm"
    const currentEtStr = `${dateObj.year}-${dateObj.month}-${dateObj.day} ${dateObj.hour}:${dateObj.minute}`;

    console.log("Current ET Time:", currentEtStr);
    console.log("Deadline ET Time:", deadlineEtStr);

    // 4. Compare strings. If current ET is past the deadline, it's Version 2.
    if (currentEtStr > deadlineEtStr) {
        return "3";
    } else {
        return "1";
    }
}

// ==========================================
// EXAMPLE USAGE
// ==========================================

// Let's set a deadline for May 29th, 2026 at 3:15 PM ET (15:15)
const myDeadline = "2026-07-08 09:00";

const activeVersion = getVersionByEtDeadline(myDeadline);
console.log("Active Version:", activeVersion);



const urlParams = new URLSearchParams(window.location.search);
console.log("url params:", Object.fromEntries(urlParams.entries()));

//const _language = String(urlParams.get("lang"));
const _language = String(urlParams.get("lang"));
//const _pack = String(urlParams.get("pack"));
//const _pack = 1;
const _pack = activeVersion;

const expr = "Papayas";
switch (_language) {
    case "eng":
        console.log("this is english");
        break;
    case "fre":
        console.log("this is french");
        break;
    case "ger":
        console.log("this is german");
        break;
    case "spa":
        console.log("this is spanish");
        break;
    case "por":
        console.log("this is portuguese");
        break;
    case "swe":
        console.log("this is swedish");
        break;
    case "pol":
        console.log("this is polish");
        break;
    case "rom":
        console.log("this is romanian");
        break;
    case "dut":
        console.log("this is dutch");
        break;
    default:
        console.log("this is english");
}

switch (_pack) {
    case "1":
        console.log("this is pack1");
        break;
    case "2":
        console.log("this is pack2");
        break;
    case "3":
        console.log("this is pack3");
        break;
    default:
        console.log("this is pack1");
}


const pad4 = (n) => String(n + 1).padStart(4, "0"); // if files start at 0001
const pad5 = (n) => String(n + 0).padStart(5, "0"); // if files start at 0001


async function goFullscreen(el = document.documentElement) {
    if (gameData.fullscreen) {
        if (el.requestFullscreen) await el.requestFullscreen();
    }

}

function GoogleAnalytics(data = {}) {
    const {
        event = "custom_event",
        label,
        category,
        value,
        params = {},        // any extra GA4 params
        debug = true,
        transport = "beacon" // helps reliability on unload
    } = data;

    // GA4-friendly params:
    // You can still send category/label, but treat them as custom params in GA4.
    const payload = {
        event_label: label,
        event_category: category,
        value: typeof value === "number" ? value : undefined,
        transport_type: transport,
        ...params
    };

    // Remove undefined keys (keeps payload clean)
    Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);

    try {
        if (typeof window.gtag === "function") {
            window.gtag("event", event, payload);
        } else if (Array.isArray(window.dataLayer)) {
            // GTM fallback: push to dataLayer so GTM can pick it up
            window.dataLayer.push({ event, ...payload });
        }
    } catch (e) {
        // swallow
    }

    if (debug) {
        console.groupCollapsed("Google-Analytics");
        console.log("event:", event);
        console.log("payload:", payload);
        console.groupEnd("Google-Analytics");
    }
}


function isLikelyWebView() {
    const ua = navigator.userAgent;

    // iOS WebView often lacks "Safari" token
    const ios = /iP(hone|ad|od)/.test(ua);
    const iosWebView = ios && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView often has "; wv" or "Version/x.x Chrome/x"
    const androidWebView = /Android/.test(ua) && (/\bwv\b/.test(ua) || /Version\/\d+\.\d+.*Chrome\/\d+/.test(ua));

    return iosWebView || androidWebView;
}

function browserMajorVersion() {
    const ua = navigator.userAgent;
    const rules = [
        { name: "Edge", re: /Edg\/(\d+)/ },
        { name: "Chrome", re: /(Chrome|CriOS)\/(\d+)/, idx: 2 },
        { name: "Firefox", re: /(Firefox|FxiOS)\/(\d+)/, idx: 2 },
        { name: "Safari", re: /Version\/(\d+)/ }, // Safari uses Version/x
    ];

    for (const r of rules) {
        const m = ua.match(r.re);
        if (m) return { name: r.name, major: Number(m[r.idx || 1]) };
    }
    return { name: "Unknown", major: null };
}

function detectBrowser() {
    const ua = navigator.userAgent;
    const isIOS = /iP(hone|ad|od)/.test(ua);
    const isAndroid = /Android/.test(ua);

    // Safari on iOS has quirks you often care about
    const isWebKit = /AppleWebKit/.test(ua);
    const isCriOS = /CriOS/.test(ua);     // Chrome iOS (still WebKit under the hood)
    const isFxiOS = /FxiOS/.test(ua);     // Firefox iOS (still WebKit)
    const isEdgiOS = /EdgiOS/.test(ua);   // Edge iOS (still WebKit)

    const isEdge = /Edg\//.test(ua) || /EdgA\//.test(ua) || /EdgiOS/.test(ua);
    const isOpera = /OPR\//.test(ua) || /Opera/.test(ua);
    const isFirefox = /Firefox\//.test(ua) || isFxiOS;
    const isChrome = (/(Chrome|CriOS)\//.test(ua)) && !isEdge && !isOpera;

    // Desktop Safari = has Safari but not Chrome/Edge/Opera
    const isSafari = /Safari\//.test(ua) && !isChrome && !isEdge && !isOpera;

    // Safari iOS specifically (not Chrome iOS etc.)
    const isSafariIOS = isIOS && isWebKit && !isCriOS && !isFxiOS && !isEdgiOS;

    let name = "Unknown";
    if (isEdge) name = "Edge";
    else if (isOpera) name = "Opera";
    else if (isFirefox) name = "Firefox";
    else if (isChrome) name = "Chrome";
    else if (isSafari) name = "Safari";

    return {
        name,
        isIOS,
        isAndroid,
        isSafariIOS,
        isWebKit,
        ua,
    };
}


async function getUAData() {
    const uaData = navigator.userAgentData;
    if (!uaData) return null;

    const high = await uaData.getHighEntropyValues([
        "brands",
        "platform",
        "platformVersion",
        "uaFullVersion",
        "model",
        "mobile",
    ]);

    return {
        brands: high.brands,     // e.g. [{brand:"Chromium",version:"..."}]
        platform: high.platform, // "macOS", "Windows", "Android", "iOS" (varies)
        mobile: high.mobile,
        uaFullVersion: high.uaFullVersion,
    };
}


function getOrientation() {
    // portrait if height >= width
    return window.matchMedia("(orientation: portrait)").matches
        ? "portrait"
        : "landscape";
}


function pauseAllMedia() {
    var videos = document.querySelectorAll('video');
    var audios = document.querySelectorAll('audio');
    for (var i = 0; i < videos.length; i++) { if (event.target != videos[i]) { videos[i].pause(); } }
    for (var i = 0; i < audios.length; i++) { if (event.target != audios[i]) { audios[i].pause(); } }
}

function onOrientationChange(cb) {
    const mq = window.matchMedia("(orientation: portrait)");

    const handler = () => cb(getOrientation());

    // Modern browsers
    if (mq.addEventListener) mq.addEventListener("change", handler);
    // Older Safari
    else mq.addListener(handler);

    // Initial fire
    handler();

    // Cleanup function
    return () => {
        if (mq.removeEventListener) mq.removeEventListener("change", handler);
        else mq.removeListener(handler);
    };
}

function formatTime(totalSeconds) {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

function isLandscape() {
    return window.matchMedia("(orientation: landscape)").matches;
}

function onLandscapeOnce(cb) {
    const mq = window.matchMedia("(orientation: landscape)");

    const handler = () => {
        if (mq.matches) {
            // cleanup + run once
            if (mq.removeEventListener) mq.removeEventListener("change", handler);
            else mq.removeListener(handler);
            cb();
        }
    };

    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);

    // if already landscape, fire immediately
    handler();

    // return cleanup (optional)
    return () => {
        if (mq.removeEventListener) mq.removeEventListener("change", handler);
        else mq.removeListener(handler);
    };
}



function updateSocialMeta(lang) {
    const content = AdContent[lang] ?? AdContent["eng"];
    const baseUrl = (content['share-url'] ?? AdContent['eng']['share-url']).replace(/\/$/, '');
    const description = (content['share-message'] ?? AdContent['eng']['share-message']).replace('$$$', '...');
    const imageUrl = `${baseUrl}/${(content['share-graphics'] ?? AdContent['eng']['share-graphics']).replace('{pack}', _pack || '1')}`;

    const setMeta = (selector, attr, value) => {
        document.querySelector(selector)?.setAttribute(attr, value);
    };

    setMeta('meta[property="og:url"]', 'content', baseUrl + '/');
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', imageUrl);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', imageUrl);
}

function populateContent(lang) {
    const content = AdContent[lang] ?? AdContent["eng"];

    // Intro title spans (.intro-title .title)
    const introTitleEls = document.querySelectorAll(".screen-intro .intro-title .title");
    const summaryLines = content.intro?.summary ?? [];
    introTitleEls.forEach((el, i) => {
        if (summaryLines[i] !== undefined) el.innerHTML = summaryLines[i];
    });

    // Intro game-slogan lines — driven by main-title in AdContent
    const mainTitle = content["main-title"];
    const introSlogan = document.querySelectorAll(".screen-intro .game-slogan .line");
    introSlogan.forEach((el, i) => {
        const val = mainTitle?.[`line-${i + 1}`];
        if (val !== undefined) el.textContent = val;
    });

    // All game slogan lines — driven by main-title in AdContent
    ["#game-shoot", "#game-save", "#game-dribble"].forEach(id => {
        document.querySelectorAll(`${id} .game-slogan .line`).forEach((el, i) => {
            const val = mainTitle?.[`line-${i + 1}`];
            if (val !== undefined) el.textContent = val;
        });
    });

    // Intro button labels
    if (content["icons"]) {
        const btnTitles = document.querySelectorAll(".screen-intro .start-buttons .btn-title");
        const btnKeys = ["icon-1", "icon-2", "icon-3"];
        btnTitles.forEach((el, i) => {
            if (content["icons"][btnKeys[i]]) el.textContent = content["icons"][btnKeys[i]].toUpperCase();
        });
    }

    // Back buttons (all screens share the same label)
    if (content["back"]) {
        document.querySelectorAll(".back-to-main span").forEach(el => {
            el.textContent = content["back"].toUpperCase();
        });
    }

    // Demo screen slogans + CTAs
    ["demo-shoot", "demo-kickup", "demo-save"].forEach(screen => {
        if (!content[screen]) return;
        const slogan = document.querySelector(`#${screen} .slogan`);
        if (slogan && content[screen].slogan) slogan.innerHTML = content[screen].slogan;
        const slogan2 = document.querySelector(`#${screen} .slogan2`);
        if (slogan2 && content[screen].slogan2) slogan2.innerHTML = content[screen].slogan2;
        const cta = document.querySelector(`#${screen} .cta span`);
        if (cta && content[screen].cta) cta.textContent = content[screen].cta.toUpperCase();
    });

    // Game-shoot instruction line
    if (content["game-shoot"]) {
        const shootTitle = document.querySelector("#game-shoot .middle-section .title");
        if (shootTitle && content["game-shoot"]["sub-title"]) shootTitle.textContent = content["game-shoot"]["sub-title"];
        const shootContinue = document.querySelector("#game-shoot .continue span");
        if (shootContinue && content["game-shoot"].continue) shootContinue.textContent = content["game-shoot"].continue.toUpperCase();
        const shootInstruction = document.querySelector("#game-shoot .instruction");
        if (shootInstruction) shootInstruction.textContent = content["game-shoot"].instruction;
        const shootResultGoal = document.querySelector("#game-shoot .display-result .goal");
        if (shootResultGoal) shootResultGoal.innerHTML = content["game-shoot"]["goal-callout"];
        const shootResultSave = document.querySelector("#game-shoot .display-result .save");
        if (shootResultSave) shootResultSave.textContent = content["game-shoot"]["miss-callout"];
        if (content["game-shoot"]["circle-goal"] && content["game-shoot"]["circle-miss"]) {
            document.querySelectorAll("#game-shoot .display-score .score .goal").forEach(el => {
                el.textContent = content["game-shoot"]["circle-goal"];
            });
            document.querySelectorAll("#game-shoot .display-score .score .save").forEach(el => {
                el.textContent = content["game-shoot"]["circle-miss"];
            });
        }
    }

    // Game-dribble title + continue
    if (content["game-dribble"]) {
        const dribbleTitle = document.querySelector("#game-dribble .middle-section .title");
        if (dribbleTitle && content["game-dribble"]["sub-title"]) dribbleTitle.textContent = content["game-dribble"]["sub-title"];
        const dribbleContinue = document.querySelector("#game-dribble .continue span");
        if (dribbleContinue && content["game-dribble"].continue) dribbleContinue.textContent = content["game-dribble"].continue.toUpperCase();
        const dribbleInstruction = document.querySelector("#game-dribble .instruction");
        if (dribbleInstruction && content["game-dribble"].instruction) dribbleInstruction.textContent = content["game-dribble"].instruction;
    }

    // Game-save
    if (content["game-save"]) {
        const saveTitle = document.querySelector("#game-save .middle-section .title");
        if (saveTitle && content["game-save"]["your-score"]) saveTitle.textContent = content["game-save"]["your-score"];
        const saveContinue = document.querySelector("#game-save .continue span");
        if (saveContinue && content["game-save"].continue) saveContinue.textContent = content["game-save"].continue.toUpperCase();
        const saveInstruction = document.querySelector("#game-save .instruction");
        if (saveInstruction && content["game-save"].instruction) saveInstruction.textContent = content["game-save"].instruction;
        const saveResultGoal = document.querySelector("#game-save .display-result .goal");
        if (saveResultGoal && content["game-save"]["goal-callout"]) saveResultGoal.innerHTML = content["game-save"]["goal-callout"];
        const saveResultSave = document.querySelector("#game-save .display-result .save");
        if (saveResultSave && content["game-save"]["save-callout"]) saveResultSave.textContent = content["game-save"]["save-callout"];
        const saveStatusSave = document.querySelector("#game-save .display-status .status-save");
        if (saveStatusSave && content["game-save"]["status-save"]) saveStatusSave.textContent = content["game-save"]["status-save"];
        const saveStatusGoal = document.querySelector("#game-save .display-status .status-goal");
        if (saveStatusGoal && content["game-save"]["status-goal"]) saveStatusGoal.textContent = content["game-save"]["status-goal"];
        if (content["game-save"]["circle-goal"] && content["game-save"]["circle-save"]) {
            document.querySelectorAll("#game-save .display-score .score .goal").forEach(el => {
                el.textContent = content["game-save"]["circle-goal"];
            });
            document.querySelectorAll("#game-save .display-score .score .save").forEach(el => {
                el.textContent = content["game-save"]["circle-save"];
            });
        }
    }

    // Social share URL
    const shareUrl = content["share-url"];
    if (shareUrl) {
        document.querySelectorAll(".social-icon[data-sharelink]").forEach(el => {
            el.dataset.sharelink = shareUrl;
        });
    }

    // End screen
    if (content.outro) {
        const endTopTitle = document.querySelector("#end .top-section .title");
        if (endTopTitle) endTopTitle.innerHTML = content.outro.title.toUpperCase();
        const endMidTitle = document.querySelector("#end .middle-section > .title");
        if (endMidTitle) endMidTitle.innerHTML = content.outro["sub-title"];
        const endSocialTitle = document.querySelector("#end .social-share .title");
        if (endSocialTitle) endSocialTitle.innerHTML = content.outro["social-title"];
        const endScoreLegendTitle = document.querySelector("#end .total-score .title");
        if (endScoreLegendTitle && content.outro["score-legend"]) endScoreLegendTitle.innerHTML = content.outro["score-legend"];
        const endBtnTitles = document.querySelectorAll("#end .start-buttons .btn-title");
        const endBtnKeys = ["icon-1", "icon-2", "icon-3"];
        endBtnTitles.forEach((el, i) => {
            if (content["icons"]?.[endBtnKeys[i]]) el.textContent = content["icons"][endBtnKeys[i]].toUpperCase();
        });
    }
}



const init = async () => {

    console.log("init");
    let wrapper = document.querySelector(".wrapper");
    let currentOrientation = "portrait";

    const browser = detectBrowser();
    console.log(browser);
    wrapper.setAttribute("data-browser", browser.name);
    wrapper.setAttribute("data-env", window.environment);
    wrapper.setAttribute("data-language", _language);
    wrapper.setAttribute("data-pack", _pack);

    const lang = AdContent[_language] ? _language : "eng";
    gameData.exitUrl = (AdContent[lang] ?? AdContent["eng"])["exit-url"];
    populateContent(lang);
    updateSocialMeta(lang);

    const gameShootBg = new VideoController('game-shoot-bg');
    const gameSaveBg = new VideoController('game-save-bg');

    function trackEvent(data) {
        GoogleAnalytics({ ...data, params: { language: lang, pack: _pack, ...data.params } });
    }

    let UAdata = getUAData();
    console.log(UAdata);

    wrapper.style.visibility = "visible";
    wrapper.classList.remove("hide");

    //document.querySelector(".loading").classList.add("hide");
    let totalScore;

    trackEvent({
        event: "ad_load",
        category: "ad",
        label: "impression",
        params: { language: lang, pack: _pack, browser: browser.name }
    });


    let gameShoot = false;
    let gameSave = false;
    let gameKickup = false;
    let gameShootValue = 0;
    let gameSaveValue = 0;
    let gameKickupValue = 0;

    let finalScorePercentage = 0;

    function getPercentage(value, total) {
        if (total === 0) return 0;
        return (value / total) * 100;
    }

    function getAverageInt(...numbers) {
        if (numbers.length === 0) return 0;
        const sum = numbers.reduce((acc, n) => acc + n, 0);
        return Math.round(sum / numbers.length);
    }

    function calculateFinalScore() {
        const totalScoreDisplay = document.querySelector("#end .score-details");
        const values = [];
        if (gameShoot) values.push(gameShootValue);
        if (gameSave) values.push(gameSaveValue);
        if (gameKickup) values.push(gameKickupValue);
        const averageValue = values.length ? getAverageInt(...values) : 0;
        totalScoreDisplay.innerHTML = averageValue + "%";
    }

    const stop = onOrientationChange((o) => {
        wrapper.setAttribute("data-orientation", o)
        console.log("Orientation:", o);
        currentOrientation = o;

        trackEvent({
            event: "device-orientation-change",
            category: "device",
            label: o
        });
    });

    let allBackToMainBtns = document.querySelectorAll(".back-to-main");
    allBackToMainBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            console.log("Back to main clicked:", btn);
            trackEvent({ event: "back_to_main", category: "navigation", label: "back-to-main" });
            wrapper.setAttribute("data-stage", "start");
        });
    });

    const closeBtn = document.querySelector(".closeBtn");
    if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            trackEvent({ event: "close_btn", category: "navigation", label: "exit" });
            window.open(gameData.exitUrl, "_blank");
        });
    }

    let introGameStartBtn = document.querySelectorAll(".intro-btn");
    introGameStartBtn.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            console.log("Back to main clicked:", btn.dataset.game);
            trackEvent({ event: "intro_game_select", category: "navigation", label: btn.dataset.game });
            wrapper.setAttribute("data-stage", btn.dataset.game);
        });
    });

    let gameStartButtons = document.querySelectorAll(".cta");
    gameStartButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            console.log("Back to main clicked:", btn.dataset.game);
            wrapper.setAttribute("data-stage", btn.dataset.game);
            console.log(btn.dataset.game);
            startGame(btn.dataset.game);
        });
    });


    let continueToEnd = document.querySelectorAll(".continue");
    continueToEnd.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            trackEvent({ event: "continue_to_end", category: "navigation", label: "end-screen" });
            wrapper.setAttribute("data-stage", "end");
        });
    });

    function injectScore(str, score) {
        return str.replace('$$$', score);
    }

    const currentContent = AdContent[lang] ?? AdContent["eng"];
    const socialSharer = new SocialShare({
        shareUrl: currentContent["share-url"] || window.location.href,
        shareGraphics: currentContent["share-graphics"]?.replace('{pack}', _pack || '1'),
    });

    let socialShareBtns = document.querySelectorAll(".social-icon");
    socialShareBtns.forEach((btn) => {
        btn.addEventListener("click", async (e) => {
            e.preventDefault();
            const platform = btn.dataset.share;
            const totalScoreValue = document.querySelector("#end .score-details").innerHTML;
            const shareText = injectScore(currentContent["share-message"], totalScoreValue);

            console.log("social share:", platform);

            trackEvent({
                event: "social-share",
                category: "share",
                label: platform
            });

            await socialSharer.share(platform, shareText);
        });
    });



    let activeSwipe = null;
    let activeIntervalID = null;
    let activeTimeoutID = null;
    let activePlayer = null;
    let activeRecognizer = null;
    let activeSoccerBallCtrl = null;
    let activeCountdown = null;

    function resetGame(whichGame) {
        if (activeCountdown) { activeCountdown.kill(); activeCountdown = null; }
        if (activeSwipe) { activeSwipe.destroy(); activeSwipe = null; }
        if (activeIntervalID) { clearInterval(activeIntervalID); activeIntervalID = null; }
        if (activeTimeoutID) { clearTimeout(activeTimeoutID); activeTimeoutID = null; }
        if (activePlayer) { try { activePlayer.destroy(); } catch (e) { } activePlayer = null; }
        if (activeRecognizer) { activeRecognizer.destroy(); activeRecognizer = null; }
        if (activeSoccerBallCtrl) { activeSoccerBallCtrl.destroy(); activeSoccerBallCtrl = null; }

        if (whichGame === "game-shoot") {
            document.querySelectorAll("#game-shoot .score-tracker .score").forEach(el => el.removeAttribute("data-status"));
            document.querySelectorAll("#game-shoot .display-score .score").forEach(el => el.removeAttribute("data-status"));
            const theBall = document.querySelector("#game-shoot .ball");
            if (theBall) { gsap.killTweensOf(theBall); gsap.set(theBall, { clearProps: "all" }); }
            gsap.killTweensOf("#game-shoot .display-result .goal");
            gsap.killTweensOf("#game-shoot .display-result .save");
            gsap.set("#game-shoot .display-result .goal", { clearProps: "all" });
            gsap.set("#game-shoot .display-result .save", { clearProps: "all" });
        }

        if (whichGame === "game-dribble") {
            document.querySelector("#game-dribble .timer-display").innerHTML = `${gameData["kickup-timer"]}:00`;
            document.querySelector("#game-dribble .score-counter").innerHTML = "0";
            document.querySelector("#game-dribble .display-score").innerHTML = "00";
            const soccerBall = document.querySelector("#game-dribble .soccer-ball");
            if (soccerBall) { gsap.killTweensOf(soccerBall); gsap.set(soccerBall, { clearProps: "all" }); }
            const dribbleEndPanel = document.querySelector("#game-dribble .middle-section");
            if (dribbleEndPanel) gsap.set(dribbleEndPanel, { clearProps: "opacity,autoAlpha" });
            const overlay = document.querySelector("#game-dribble .overlay");
            if (overlay) {
                const newOverlay = overlay.cloneNode(true);
                overlay.parentNode.replaceChild(newOverlay, overlay);
            }
        }

        if (whichGame === "game-save") {
            document.querySelectorAll("#game-save .score-tracker .score").forEach(el => el.removeAttribute("data-status"));
            document.querySelectorAll("#game-save .display-score .score").forEach(el => el.removeAttribute("data-status"));
            const theBall = document.querySelector("#game-save .ball");
            if (theBall) { gsap.killTweensOf(theBall); gsap.set(theBall, { clearProps: "all" }); }
            gsap.killTweensOf("#game-save .display-result .goal");
            gsap.killTweensOf("#game-save .display-result .save");
            gsap.set("#game-save .display-result .goal", { clearProps: "all" });
            gsap.set("#game-save .display-result .save", { clearProps: "all" });
            const saveEndPanel = document.querySelector("#game-save .middle-section");
            if (saveEndPanel) gsap.set(saveEndPanel, { clearProps: "opacity,autoAlpha" });
            [1, 2, 3, 4, 5].forEach(i => {
                const dot = document.querySelector(`#dot-${i}`);
                if (dot) {
                    const newDot = dot.cloneNode(true);
                    dot.parentNode.replaceChild(newDot, dot);
                }
            });
        }
    }

    async function startGame(whichGame) {

        trackEvent({ event: "game_start", category: "game", label: whichGame });
        resetGame(whichGame);

        let ScreenShoot = document.querySelector("#game-shoot");
        let ScreenSave = document.querySelector("#game-save");
        let ScreenDribble = document.querySelector("#game-dribble");

        /* :::::::::::::::::::: GAME SHOOT :::::::::::::::::::::: */

        if (whichGame == "game-shoot") {

            let totalPoint = 5;
            let totalGoal = 0;

            ScreenShoot.setAttribute("data-status", "loading");

            let shoot = await new CanvasSequencePlayer({
                canvas: "#seqCanvas",
                frameCount: 241,
                frames: (i) => `images/gameshoot/gameshoot_${pad5(i)}.png`,
                fit: "contain",
                preload: true,
            }).init();
            activePlayer = shoot;

            ScreenShoot.setAttribute("data-status", "countdown");

            const countdown = new GSAPCountdown("#game-shoot .large-number", {
                holdTime: 0,
                delayBetween: 0,
                reverse: false,
                onComplete: () => {
                    ScreenShoot.setAttribute("data-status", "playing");
                    gameShoot = true;
                    console.log("countdown finished :: shoot");
                }
            });
            activeCountdown = countdown;
            countdown.play();

            const gameContainer = document.getElementById("game-shoot");

            const recognizer = new GestureRecognizer(gameContainer, (gesture) => {
                console.log("gesture: ", gesture);
                dynamicBallShot(gesture);
            });
            activeRecognizer = recognizer;


            let counter = 0;
            let isShotAnimating = false;

            function dynamicBallShot(gesture) {
                const POWER_THRESHOLD = 1200; // px/s — above this = "strong" shot
                const { direction, power } = gesture;
                const isStrong = power >= POWER_THRESHOLD;

                let userOptionSelected;
                if (direction === 'Center') {
                    userOptionSelected = 5;
                } else if (direction === 'Left' && isStrong) {
                    userOptionSelected = 1; // Left High
                } else if (direction === 'Left' && !isStrong) {
                    userOptionSelected = 2; // Left Low
                } else if (direction === 'Right' && !isStrong) {
                    userOptionSelected = 3; // Right Low
                } else if (direction === 'Right' && isStrong) {
                    userOptionSelected = 4; // Right High
                }

                shootTheBall(userOptionSelected, gesture.curve, gesture);
            }

            function mapYvalue(value) {
                console.log("power value: ", value);
                let outputInString;
                const inMin = 450;
                const inMax = 4000;
                const outMin = -100;
                const outMax = -350;
                const clamped = Math.min(Math.max(value, inMin), inMax);
                outputInString = (outMin + ((clamped - inMin) / (inMax - inMin)) * (outMax - outMin));
                //  return outMin + ((clamped - inMin) / (inMax - inMin)) * (outMax - outMin);
                return outputInString;
            }

            function mapXvalue(value, dir) {
                console.log("x value: ", value, dir);

                // --- Input range: curve value from GestureRecognizer (0 = straight, 10 = max curve) ---
                const inMin = 0;   // minimum curve detected
                const inMax = 10;  // maximum curve detected

                // --- Output range: horizontal CSS % offset applied to the ball's destination ---
                // Increase outMax to make curved shots travel further left/right
                const outMin = 0;   // straight shot = no horizontal offset
                const outMax = 50; // max horizontal offset (%) at full curve
                /*
                    90 = very wide, ball can fly far off-screen
                    50 = moderate, stays closer to center
                    30 = tight, ball stays near the goal post
                */

                // Clamp the raw value so it never exceeds the input range
                const v = Math.min(Math.max(value, inMin), inMax);

                // Linear map: converts curve 0–10 → offset 0–outMax
                let calculatedValue = outMin + ((v - inMin) / (inMax - inMin)) * (outMax - outMin);

                // Flip sign: Right = positive (move right), Left = negative (move left)
                if (dir == "Right") { calculatedValue = calculatedValue * 1; }
                else { calculatedValue = calculatedValue * -1; }

                return calculatedValue;
            }

            function randomInt(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }

            function checkingForGoal(whichOne, jumpdirection, index) {

                console.log("jump direction ", jumpdirection);

                const directions = [
                    ".upper-left",
                    ".lower-left",
                    ".lower-right",
                    ".upper-right",
                    ".center"
                ];

                const jumpDirectionString = directions[jumpdirection - 1];

                let scoreGoal = document.querySelector("#game-shoot .display-result .goal");
                let scoreSave = document.querySelector("#game-shoot .display-result .save");
                let displayScore = document.querySelector("#game-shoot .display-score .score-" + index);
                let scoreTracker = document.querySelector("#game-shoot .score-tracker .score-" + index);

                console.log(" collision detected ", whichOne);

                if (whichOne == "missed") {
                    console.log("ball outside the post");
                    trackEvent({ event: "shoot_result", category: "game-shoot", label: "miss", value: index });
                    scoreTracker.setAttribute("data-status", "save");
                    displayScore.setAttribute("data-status", "save");
                    gsap.fromTo(scoreSave, { opacity: 0, scale: 0.5 }, { duration: .3, delay: 0.8, opacity: 1, scale: 1.4 });
                    gsap.to(scoreSave, { opacity: 0, duration: 0.1, delay: 1.5 });

                }
                else {
                    if (whichOne == jumpDirectionString) {
                        console.log("ball saved");
                        trackEvent({ event: "shoot_result", category: "game-shoot", label: "saved", value: index });
                        gsap.fromTo(scoreSave, { opacity: 0, scale: 0.5 }, { duration: .3, delay: 0.8, opacity: 1, scale: 1.4 });
                        gsap.to(scoreSave, { opacity: 0, duration: 0.1, delay: 1.5 });
                        scoreTracker.setAttribute("data-status", "save");
                        displayScore.setAttribute("data-status", "save");
                    }
                    else {
                        console.log("Goal happended");
                        gameShootBg.togglePlay();
                        trackEvent({ event: "shoot_result", category: "game-shoot", label: "goal", value: index });
                        totalGoal++;
                        gsap.fromTo(scoreGoal, { opacity: 0, scale: 0.5 }, { delay: 0.8, duration: .3, opacity: 1, scale: 1.4 });
                        gsap.to(scoreGoal, { opacity: 0, duration: 0.1, delay: 1.5 });

                        setTimeout(() => {
                            scoreTracker.setAttribute("data-status", "goal");
                            displayScore.setAttribute("data-status", "goal");
                        }, 1000);
                    }
                }

            }

            function shootTheBall(userSelected, curveAmount = 0, swipeDetail) {
                console.log("shoot the ball");

                let xValNum = mapXvalue(swipeDetail.curve, swipeDetail.direction);
                let yValNum = mapYvalue(swipeDetail.power);
                let xVal = xValNum + "%";
                let yVal = yValNum + "%";
                let xValCurve = (xValNum + 20) + "%";
                let yValCurve = (yValNum / 2) + "%";

                const options = [
                    "",
                    [-100, -180],
                    [-100, -100],
                    [100, -100],
                    [100, -180],
                    [0, -100],
                ];

                if (counter >= totalPoint || isShotAnimating) return;

                if (counter === 0) {
                    trackEvent({ event: "first_interaction", category: "game-shoot", label: "first_swipe" });
                }

                const randomRotation = Math.floor(Math.random() * 101) - 50;
                isShotAnimating = true;
                counter++;

                let jumpDirection = randomInt(1, 5);
                catchTheBall(jumpDirection, counter);

                if (swipeDetail.type == "straight") {
                    xValCurve = "0%";
                    yValCurve = "0%";
                }

                const theBall = document.querySelector("#game-shoot .ball");
                gsap.set(theBall, { opacity: 1 });

                console.groupCollapsed("details");
                console.log("swipe details: ", swipeDetail);
                console.log("jump direction: ", jumpDirection);
                console.groupEnd();

                gsap.fromTo(theBall, {
                    scale: 1, rotation: 0, x: "0%", y: "0%"
                }, {
                    scale: 0.15,
                    duration: 1,
                    motionPath: {
                        path: [{ x: xValCurve, y: yValCurve }, { x: xVal, y: yVal }],
                        curviness: 3
                    },
                    onComplete: () => {

                        const ballRect = theBall.getBoundingClientRect();
                        const ballCx = ballRect.left + ballRect.width / 2;
                        const ballCy = ballRect.top + ballRect.height / 2;

                        const zones = [".center", ".upper-left", ".upper-right", ".lower-left", ".lower-right", ".inside"];
                        let hitZone = null;

                        for (const sel of zones) {
                            const el = document.querySelector(`#game-shoot .goal-post ${sel}`);
                            if (!el) continue;
                            const r = el.getBoundingClientRect();
                            if (ballCx >= r.left && ballCx <= r.right && ballCy >= r.top && ballCy <= r.bottom) {
                                hitZone = sel;
                                break;
                            }
                        }

                        let outcome = hitZone ?? "missed";

                        //console.log("Ball hit zone:", hitZone ?? "missed");
                        checkingForGoal(outcome, jumpDirection, counter);

                        gsap.to(theBall, {
                            duration: 0.1, opacity: 1, scale: 1, x: 0, y: 0, rotation: 0,
                            onComplete: () => {
                                if (counter < totalPoint) isShotAnimating = false;
                                else {
                                    activeTimeoutID = setTimeout(() => {
                                        activeTimeoutID = null;
                                        document.querySelector("#game-shoot").setAttribute("data-status", "end");
                                        let scorePercentage = getPercentage(totalGoal, totalPoint);
                                        gameShootValue = scorePercentage;
                                        calculateFinalScore();
                                        trackEvent({ event: "game_end", category: "game-shoot", label: "complete", value: totalGoal });
                                        totalGoal = 0;
                                        gameShoot = true;
                                    }, 2000);

                                }

                            }
                        });
                    }

                });

            }

            function catchTheBall(whichOne, index) {

                console.log("catch the ball ", index);

                let displayScore = document.querySelector("#game-shoot .display-score .score-" + index);
                let scoreTracker = document.querySelector("#game-shoot .score-tracker .score-" + index);
                let scoreGoal = document.querySelector("#game-shoot .display-result .goal");
                let scoreSave = document.querySelector("#game-shoot .display-result .save");

                //  const num = Math.floor(Math.random() * 5) + 1;

                //  console.log(":::: WHICHONE :::: ", whichOne);

                if (whichOne == 1) {
                    shoot.playRange(49, 95 + 2, { duration: 1, loop: false });
                }
                else if (whichOne == 2) {
                    shoot.playRange(96, 143 + 1, { duration: 1, loop: false });
                }
                else if (whichOne == 3) {
                    shoot.playRange(192, 240, { duration: 1, loop: false });
                }
                else if (whichOne == 4) {
                    shoot.playRange(144, 190 + 2, { duration: 1, loop: false });
                }
                else if (whichOne == 5) {
                    shoot.playRange(1, 48 + 1, { duration: 1, loop: false });
                }
            }
        }

        /* :::::::::::::::::::: GAME DRIBBLE :::::::::::::::::::::: */

        if (whichGame == "game-dribble") {

            let totalKickUp = 20;
            let userKickUp = 0;

            const soccerBall = document.querySelector("#game-dribble .soccer-ball");
            gsap.set(soccerBall, { opacity: 0 });

            ScreenDribble.setAttribute("data-status", "loading");

            const game = new SoccerBallController(soccerBall, {
                gravity: 0.4,
                kickStrength: -15,
                groundY: 300,
                inputTarget: null,
                onUpdate: ({ y, vy }) => {
                    // console.log("ball y:", y, "vy:", vy);
                },
            });

            let dribble = await new CanvasSequencePlayer({
                canvas: "#seqCanvas2",
                frameCount: 15,
                //   frames: (i) => `images/dribble/dribble_${pad5(i)}.png`,
                frames: (i) => `images/kickupSeq/kup_${pad5(i)}.png`,
                fit: "contain",
                preload: true,
            }).init();

            activePlayer = dribble;
            ScreenDribble.setAttribute("data-status", "countdown");

            let counter = 0;
            let timerCount = 0;
            let totalTime = gameData["kickup-timer"];

            const timerDisplay = document.querySelector("#game-dribble .timer-display");
            const scoreCounter = document.querySelector("#game-dribble .score-counter")

            //dribble.playRange(10, 15, { duration: .5, loop: true });
            dribble.playRange(15, 15, { duration: .1 });

            activeSoccerBallCtrl = game;

            const countdown = new GSAPCountdown("#game-dribble .large-number", {
                holdTime: 0,
                delayBetween: 0,
                reverse: false,
                onComplete: () => {
                    activeIntervalID = setInterval(activeHS, 1000, game.y);
                    ScreenDribble.setAttribute("data-status", "playing");
                    game.start();
                    gsap.set(soccerBall, { opacity: 1 });
                }
            });
            activeCountdown = countdown;
            countdown.play();

            let displayScore = document.querySelector("#game-dribble .display-score");
            let overlayElement = document.querySelector("#game-dribble .overlay");
            overlayElement.classList.add("show");
            overlayElement.addEventListener("click", () => {
                if (game.y < 150) return;

                if (counter === 0) {
                    trackEvent({ event: "first_interaction", category: "game-kickup", label: "first_kick" });
                }

                if (game.y < 250) {
                    console.log("ball y position: ", game.y);
                    counter++;
                    scoreCounter.innerHTML = counter;
                    displayScore.innerHTML = counter;
                }

                game.kick();
                dribble.playRange(0, 10, { duration: 0.4, loop: false });
            })


            function activeHS(ballY) {
                console.log(":::: kick up ::::");

                timerCount++;
                let remainingTime = totalTime - timerCount;
                timerDisplay.innerHTML = remainingTime + ":00";

                if (timerCount == totalTime) {
                    clearInterval(activeIntervalID);
                    activeIntervalID = null;
                    trackEvent({ event: "game_end", category: "game-kickup", label: "complete", value: counter });
                    const endPanel = document.querySelector("#game-dribble .middle-section");
                    gsap.set(endPanel, { opacity: 0 });
                    ScreenDribble.setAttribute("data-status", "end");
                    gsap.to(endPanel, { opacity: 1, duration: 0.8, ease: "power2.out" });
                    dribble.destroy();
                    activePlayer = null;
                    game.stop();

                    gameKickup = true;

                    let scorePercentage = getPercentage(counter, totalTime);
                    gameKickupValue = scorePercentage;
                    calculateFinalScore();
                    counter = 0;
                    // totalGoal = 0;

                    // console.log(" kickup ended :::: ", counter);

                }
            }

        }

        /* :::::::::::::::::::: GAME SAVE :::::::::::::::::::::: */

        if (whichGame == "game-save") {

            let totalPlay = 5;

            ScreenSave.setAttribute("data-status", "loading");

            let save = await new CanvasSequencePlayer({
                canvas: "#seqCanvas3",
                frameCount: 240,
                frames: (i) => `images/goal/gamesave_${pad5(i)}.png`,
                fit: "contain",
                preload: true,
            }).init();
            activePlayer = save;

            setTimeout(() => {
                ScreenSave.setAttribute("data-status", "countdown");
                const countdown = new GSAPCountdown("#game-save .large-number", {
                    holdTime: 0,
                    delayBetween: 0.2,
                    reverse: false,
                    onComplete: () => {
                        ScreenSave.setAttribute("data-status", "playing");
                    }
                });
                activeCountdown = countdown;
                countdown.play();
            }, 100);


            save.playRange(6, 7, { duration: .5, loop: true });
            let dot1 = document.querySelector(".dots #dot-1");
            let dot2 = document.querySelector(".dots #dot-2");
            let dot3 = document.querySelector(".dots #dot-3");
            let dot4 = document.querySelector(".dots #dot-4");
            let dot5 = document.querySelector(".dots #dot-5");

            dot1.addEventListener("click", saveDotClicked);
            dot2.addEventListener("click", saveDotClicked);
            dot3.addEventListener("click", saveDotClicked);
            dot4.addEventListener("click", saveDotClicked);
            dot5.addEventListener("click", saveDotClicked);

            function saveDotClicked() {
                console.log(this.dataset.index);
                let currentIndex = this.dataset.index;

                SaveTheBall(currentIndex);

                if (currentIndex == 1) {
                    save.playRange(49, 95, { duration: 1, loop: false });
                }

                else if (currentIndex == 2) {
                    save.playRange(144, 190, { duration: 1, loop: false });
                }

                else if (currentIndex == 3) {
                    save.playRange(192, 239, { duration: 1, loop: false });
                }

                else if (currentIndex == 4) {
                    save.playRange(96, 143, { duration: 1, loop: false });
                }

                else if (currentIndex == 5) {
                    save.playRange(1, 48, { duration: 1, loop: false });
                }
            }

            let pointTracker = [];
            let counter = 0;
            let userSave = 0;

            function SaveTheBall(userSelected) {

                console.log(":::: save the ball ::::");

                if (counter === 0) {
                    trackEvent({ event: "first_interaction", category: "game-save", label: "first_dive" });
                }

                const num = Math.floor(Math.random() * 5) + 1;

                counter++;

                let currentScoreDot = document.querySelector("#game-save .score-tracker .score-" + counter);
                let currentDisplayDot = document.querySelector("#game-save .display-score .score-" + counter);
                let scoreGoal = document.querySelector("#game-save .display-result .goal");
                let scoreSave = document.querySelector("#game-save .display-result .save");


                let options = [
                    "",
                    ["-90%", "-160%"],
                    ["90%", "-160%"],
                    ["90%", "-85%"],
                    ["-90%", "-85%"],
                    ["0%", "-100%"],
                ]

                const theBall = document.querySelector("#game-save .ball");
                gsap.set(theBall, { opacity: 1 });
                gsap.fromTo(theBall, { x: 0, y: 0, scale: 1 }, {
                    x: options[num][0], y: options[num][1], duration: 1, scale: 0.2, onComplete: () => {

                        save.playRange(6, 7, { duration: .5, loop: true });

                        let currentScore;

                        if (num == userSelected) {
                            console.log("SAVE");
                            currentScore = "save";
                            userSave++;
                            currentScoreDot.setAttribute("data-status", "goal");
                            currentDisplayDot.setAttribute("data-status", "goal");
                            gsap.fromTo(scoreSave, { opacity: 0, scale: 0.5 }, { duration: .3, delay: 0, opacity: 1, scale: 1.4 });
                            gsap.to(scoreSave, { opacity: 0, duration: 0.1, delay: 1 });
                            trackEvent({ event: "save_result", category: "game-save", label: "saved", value: counter });
                            console.group("details:");
                            console.log(num);
                            console.groupEnd();

                            ballAfterwards("save", num);
                        }
                        else {
                            console.log("GOAL");
                            currentScore = "goal";
                            currentScoreDot.setAttribute("data-status", "save");
                            currentDisplayDot.setAttribute("data-status", "save");
                            gsap.fromTo(scoreGoal, { opacity: 0, scale: 0.5 }, { duration: .3, delay: 0, opacity: 1, scale: 1 });
                            gsap.to(scoreGoal, { opacity: 0, duration: 0.1, delay: 1 });
                            trackEvent({ event: "save_result", category: "game-save", label: "conceded", value: counter });
                            ballAfterwards("goal", userSelected, num);
                            gameSaveBg.togglePlay();
                        }

                        pointTracker.push(currentScore);
                        console.log("pointTracker: ", pointTracker);

                        if (counter == (totalPlay)) {

                            const saves = pointTracker.filter(r => r === "save").length;
                            trackEvent({ event: "game_end", category: "game-save", label: "complete", value: saves });
                            activeTimeoutID = setTimeout(() => {
                                activeTimeoutID = null;
                                const endPanel = document.querySelector("#game-save .middle-section");
                                gsap.set(endPanel, { opacity: 0 });
                                ScreenSave.setAttribute("data-status", "end");
                                gsap.to(endPanel, { opacity: 1, duration: 0.8, ease: "power2.out" });
                                save.destroy();
                                activePlayer = null;
                            }, 1000);

                            gameSave = true;
                            console.log("user save: ", userSave);
                            console.log("total play: ", totalPlay);

                            let scorePercentage = getPercentage(userSave, totalPlay);
                            console.log("score percentage: ", scorePercentage);
                            gameSaveValue = scorePercentage;
                            calculateFinalScore();
                            userSave = 0;
                            // gameShootValue = scorePercentage;
                            // calculateFinalScore(scorePercentage);
                            // totalGoal = 0;
                            // //console.log(" game ended shoot ", scorePercentage);
                            // gameShoot = true;

                        }


                    }
                });

                function ballAfterwards(whichOne, userSelected, shoot) {
                    //gsap.set(theBall, { opacity: 0 });
                    //gsap.to(theBall, { duration: 0.2, x: "-200%" });
                    console.groupCollapsed("details:");
                    console.log("save or goal: ", whichOne);
                    console.log("userSelected: ", userSelected);
                    console.log("shoot number: ", shoot);
                    console.groupEnd();

                    if (whichOne == "save") {
                        if ((userSelected == 1) || (userSelected == 4)) {
                            gsap.to(theBall, { duration: 0.2, x: "-200%" });
                        }

                        else if ((userSelected == 2) || (userSelected == 3)) {
                            gsap.to(theBall, { duration: 0.2, x: "200%" });
                        }

                        else if ((userSelected == 5)) {
                            gsap.to(theBall, { opacity: 0, duration: 0.2, x: "0%" });
                        }
                    }
                    else {
                        gsap.to(theBall, { opacity: 0, duration: 0.2 });
                    }


                }


            }



            function gameResult() {

            }
        }

    }




}


window.addEventListener("load", (event) => { init(); });